<template>
  <div class="d-flex flex-column flex-grow-1">
    <BaseTopLine></BaseTopLine>
    <div
      class="tw-bg-main2 tw-py-[10px] tw-px-[20px] tw-rounded-[6px] tw-mx-[26px] tw-text-[12px]"
    >
      <div
        class="tw-flex tw-items-end tw-gap-[20px] tw-text-white tw-max-w-[430px]"
      >
        <div class="tw-app-input-container">
          <label class="tw-app-input-container-label"> Наименование </label>
          <BaseInputNew
            @keyupEnter="getWithFilter()"
            inputClass="tw-app-input-dark"
            @input="filters.title.value = $event.value"
            :value="filters.title.value"
          />
        </div>
        <div class="tw-flex tw-flex-row">
          <button
            type="button"
            class="tw-app-btn-primary"
            @click="getWithFilter()"
          >
            Найти
          </button>
          <button type="button" class="tw-app-btn-light" @click="resetFilter()">
            Сбросить
          </button>
        </div>
      </div>
    </div>

    <div class="tw-px-[26px]">
      <div class="tw-my-[15px] tw-flex tw-items-center tw-gap-[10px]">
        <button
          class="tw-app-btn-primary"
          @click="$modal.show('AddPassToBook')"
        >
          <img
            :src="require(`@/assets/icons/addwhite.svg`)"
            width="13.5"
            height="13.5"
            class="tw-my-[-5px]"
          />
          Добавить
        </button>
        <button class="tw-app-btn-primary-outline" @click="setRemovePass()">
          <img
            :src="require(`@/assets/icons/minus-dark.svg`)"
            width="13.5"
            height="13.5"
            class="tw-my-[-5px]"
          />
          Удалить
        </button>
      </div>
    </div>

    <div class="tw-px-[26px]">
      <!-- <div class="tw-flex tw-justify-end tw-pb-[15px]">
        <TwBasePagination
          :page-count="bookPhonesData.total / bookPhonesData.limit"
          :pagination-params="{ ...bookPhonesData, limit: limit }"
          @updateLimitValue="(limit = $event), getData()"
          :page-range="10"
          :margin-pages="0"
          :click-handler="getWithFilter"
        >
        </TwBasePagination> 
      </div>-->
      <ve-table
        class="rest-style-table"
        style="width: 100%"
        :columns="columns"
        :table-data="bookPasswordsDataFiltered.rows || []"
        :border-x="true"
        :border-y="true"
        row-key-field-name="book_passwords__id"
        :checkbox-option="{
          hideSelectAll: false,
          selectedRowChange: selectedRowChange,
          selectedAllChange: selectedAllChange,
        }"
        :clickHighlight="false"
        :eventCustomOption="eventCustomOption"
        :rowStyleOption="{
          hoverHighlight: true,
        }"
        :cellSelectionOption="{ enable: false }"
      />
    </div>

    <BaseModal
      name="AddPassToBook"
      width="420"
      height="auto"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      classes="!tw-bg-transparent !tw-shadow-none"
      @before-close="resetNewPass()"
    >
      <div
        class="tw-bg-white tw-rounded-[25px] tw-py-[38px] tw-px-[30px] tw-relative tw-text-forTitle"
      >
        <button
          type="button"
          class="btn-close tw-absolute tw-right-[30px] tw-top-[20px] !tw-shadow-none"
          @click="$modal.hide('AddPassToBook')"
        ></button>

        <div>
          <div class="tw-app-modal__title">
            {{
              newPassword.book_passwords__id
                ? "Редактировать запись"
                : "Добавить пароль"
            }}
          </div>
          <div class="tw-mb-[15px]">
            <div class="tw-app-input-type-3-label">Наименование</div>
            <BaseInputNew
              inputClass="tw-app-input-type-3"
              @input="newPassword.book_passwords__name = $event.value"
              :value="newPassword.book_passwords__name"
            ></BaseInputNew>
          </div>

          <div class="tw-mb-[15px]">
            <div class="tw-app-input-type-3-label">Ссылка</div>
            <BaseInputNew
              inputClass="tw-app-input-type-3"
              @input="newPassword.book_passwords__link = $event.value"
              :value="newPassword.book_passwords__link"
            ></BaseInputNew>
          </div>

          <div class="tw-mb-[15px]">
            <div class="tw-app-input-type-3-label">Логин</div>
            <BaseInputNew
              inputClass="tw-app-input-type-3"
              @input="newPassword.book_passwords__login = $event.value"
              :value="newPassword.book_passwords__login"
            ></BaseInputNew>
          </div>

          <div class="tw-mb-[15px]">
            <div class="tw-app-input-type-3-label">Пароль</div>
            <BaseInputNew
              inputClass="tw-app-input-type-3"
              @input="newPassword.book_passwords__password = $event.value"
              :value="newPassword.book_passwords__password"
            ></BaseInputNew>
          </div>

          <div class="tw-mb-[15px]">
            <div class="tw-app-input-type-3-label">Описание</div>
            <BaseInputNew
              inputClass="tw-app-input-type-3"
              @input="newPassword.book_passwords__description = $event.value"
              :value="newPassword.book_passwords__description"
            ></BaseInputNew>
          </div>

          <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
            <button
              @click="$modal.hide('AddPassToBook')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              Отменить
            </button>
            <button
              @click="submit"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
              :disabled="submitting"
            >
              Сохранить
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="RemovePass"
      width="420"
      height="auto"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      classes="!tw-bg-transparent !tw-shadow-none"
    >
      <div
        class="tw-bg-white tw-rounded-[25px] tw-py-[38px] tw-px-[30px] tw-relative tw-text-forTitle"
      >
        <button
          type="button"
          class="btn-close tw-absolute tw-right-[30px] tw-top-[20px] !tw-shadow-none"
          @click="$modal.hide('RemovePass')"
        ></button>

        <div class="tw-text-center">
          <div class="tw-text-[23px] tw-mb-[15px]">Удалить запись?</div>

          <div class="tw-h-[10px]"></div>

          <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
            <button
              @click="$modal.hide('RemovePass')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              Отменить
            </button>
            <button
              @click="removePass()"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              Выполнить
            </button>
          </div>
        </div>
      </div>
    </BaseModal>
  </div>
</template>

<script>
import GeneralService from "@/api/GeneralService";
import { VeTable } from "vue-easytable";

export default {
  components: {
    VeTable,
  },
  data() {
    return {
      activeSelectRowsMultiple: [],
      bookPasswordsData: {},
      bookPasswordsDataFiltered: {},
      newPassword: {
        book_passwords__id: null,
        book_passwords__name: "",
        book_passwords__link: "",
        book_passwords__login: "",
        book_passwords__password: "",
        book_passwords__description: "",
      },
      submitting: false,
      filters: {
        title: {
          value: null,
        },
      },
      limit: 500,
      eventCustomOption: {
        bodyRowEvents: ({ row, rowIndex }) => {
          return {
            dblclick: (event) => {
              this.newPassword.book_passwords__id = row.book_passwords__id;
              this.newPassword.book_passwords__name = row.book_passwords__name;
              this.newPassword.book_passwords__link = row.book_passwords__link;
              this.newPassword.book_passwords__login =
                row.book_passwords__login;
              this.newPassword.book_passwords__password =
                row.book_passwords__password;
              this.newPassword.book_passwords__description =
                row.book_passwords__description;
              setTimeout(() => this.$modal.show("AddPassToBook"), 10);
            },
          };
        },
      },
    };
  },
  created() {
    this.getData();
  },
  computed: {
    columns() {
      return [
        {
          field: "",
          key: "a",
          type: "checkbox",
          title: "",
          width: "2%",
          align: "center",
        },
        {
          field: "book_passwords__name",
          key: "book_passwords__name",
          title: "Наименование",
          align: "center",
          width: "10%",
        },
        {
          field: "book_passwords__link",
          key: "book_passwords__link",
          title: "Ссылка",
          align: "center",
          width: "10%",
        },
        // {
        //   field: "book_passwords__login",
        //   key: "book_passwords__login",
        //   title: "Логин",
        //   align: "center",
        //   width: "10%",
        // },
        // {
        //   field: "book_passwords__password",
        //   key: "book_passwords__password",
        //   title: "Пароль",
        //   align: "center",
        //   width: "10%",
        // },
        {
          field: "book_passwords__description",
          key: "book_passwords__description",
          title: "Описание",
          align: "center",
          width: "10%",
        },
      ];
    },
  },

  methods: {
    resetFilter() {
      this.filters.title.value = null;
      this.getData();
    },
    setRemovePass() {
      if (this.activeSelectRowsMultiple?.length) {
        this.$modal.show("RemovePass");
      } else {
        this.$toast.error("Выберите хотя-бы одно поле", { duration: 5000 });
      }
    },
    removePass() {
      GeneralService.delete(`/book-passwords/${this.activeSelectRowsMultiple}`)
        .then((data) => {
          this.$toast.success(data.data.message, { duration: 5000 });
          this.getData();
        })
        .catch((e) => {
          this.$toast.error(e.response.data.message, { duration: 5000 });
        });
      this.$modal.hide("RemovePass");
    },
    resetNewPass() {
      this.newPassword.book_passwords__id = null;
      this.newPassword.book_passwords__name = "";
      this.newPassword.book_passwords__link = "";
      this.newPassword.book_passwords__login = "";
      this.newPassword.book_passwords__password = "";
      this.newPassword.book_passwords__description = "";
    },
    submit() {
      this.submitting = true;
      if (this.newPassword.book_passwords__id) {
        GeneralService.edit(
          `/book-passwords/${this.newPassword.book_passwords__id}`,
          this.newPassword
        )
          .then((data) => {
            this.$toast.success(data.data.message);
            this.$modal.hide("AddPassToBook");
            this.getData();
          })
          .finally(() => {
            this.submitting = false;
          });
      } else {
        GeneralService.editOrCreate(`/book-passwords`, this.newPassword)
          .then((data) => {
            this.resetNewPass();
            this.$toast.success(data.data.message);
            this.$modal.hide("AddPassToBook");
            this.getData();
          })
          .finally(() => {
            this.submitting = false;
          });
      }
    },
    selectedRowChange({ selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    selectedAllChange({ selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    getData(where = [], page = 1) {
      GeneralService.get(`/book-passwords`, {
        params: {
          where: JSON.stringify(where),
          page: page,
          limit: this.limit,
        },
      })
        .then((data) => {
          this.bookPasswordsData = structuredClone(data.data.data);
          this.bookPasswordsDataFiltered = structuredClone(data.data.data);
        })
        .catch((e) => {
          this.$toast.error(e.response.data.message, { duration: 5000 });
        });
    },
    getWithFilter() {
      if (this.filters?.title?.value?.length) {
        this.bookPasswordsDataFiltered.rows =
          this.bookPasswordsData.rows.filter((i) =>
            String(i.book_passwords__name)
              ?.toLowerCase()
              ?.includes(this.filters?.title?.value?.toLowerCase())
          );
      } else {
        this.bookPasswordsDataFiltered.rows = this.bookPasswordsData.rows;
      }
    },
  },
};
</script>
